<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Остановка передачи в БКИ</template>
        <template #content>
          <TabView>
            <TabPanel header="Остановка по заявке">
              <AbstractForm
                  ref="form"
                  :loading="loading"
                  v-model="form"
                  :on-commit="processStop"
                  commit-label="Остановить"
                  commit-icon="pi pi-stop"
              ></AbstractForm>
            </TabPanel>
            <TabPanel header="Список остановленных передач">
              <AbstractTable
                  ref="table"
                  code="sendStops"
                  display-filter="menu"
                  :expander="true"
              >
                <template #expand="{row}">
                  <div class="flex gap-2">
                    <Button
                        class="p-button-danger"
                        :loading="deletingStop"
                        label="Удалить остановку"
                        icon="pi pi-trash"
                        @click="deleteStop(row.data.id, row.data.applicationUuid)"
                    ></Button>
                  </div>
                </template>
              </AbstractTable>
            </TabPanel>
          </TabView>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import AbstractForm from "@/components/AbstractForm";
import AbstractTable from "@/components/AbstractTable";
import FormModel from "@/model/FormModel";
import CRUDService from "@/service/CRUDService";
import ResponseService from "@/service/ResponseService";

export default {
  name: "StopLoad",
  components: {AbstractForm, AbstractTable},
  data() {
    return {
      loading: false,
      form: {
        applicationUuid: new FormModel('UUID заявок / займов (через запятую)')
      },
      deletingStop: false,
    }
  },
  methods: {
    deleteStop(id, applicationUuid) {
      this.$confirm.require({
        message: `Вы уверены, что хотите удалить остановку передачи для заявки "${applicationUuid}"?`,
        header: 'Подтверждение удаления',
        acceptLabel: 'Удалить',
        acceptIcon: 'pi pi-trash',
        acceptClass: 'p-button-danger',
        rejectLabel: 'Отмена',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.$confirm.close()
          this.deletingStop = true

          CRUDService.delete('send_stop', id).then(() => {
            this.$toast.add({
              severity: 'success',
              summary: 'Остановка удалена',
              detail: `Остановка передачи для заявки "${applicationUuid}" удалена`,
              life: 2000
            })
            this.$refs.table.getData()
            this.deletingStop = false
          }).catch((err) => {
            ResponseService.handleErrorResponseWithoutForm(err, this.$toast)
            this.deletingStop = false
          })
        }
      })
    },
    processStop() {
      const uuids = typeof this.form.applicationUuid.value === 'string'
          ? this.form.applicationUuid.value.split(',').map(uuid => uuid.trim()).filter(uuid => uuid.length > 0)
          : []

      if (uuids.length === 0) {
        this.$toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Не указан ни один UUID',
          life: 3000
        })
        return
      }

      const message = uuids.length === 1
          ? `Вы уверены, что хотите остановить передачу по заявке "${uuids[0]}"?`
          : `Вы уверены, что хотите остановить передачу по ${uuids.length} заявкам?`

      this.$confirm.require({
        message: message,
        header: 'Подтвердите остановку передачи',
        acceptLabel: 'Остановить',
        acceptIcon: 'pi pi-stop',
        rejectLabel: 'Отмена',
        rejectIcon: 'pi pi-ban',
        accept: () => {
          this.$confirm.close()
          this.loading = true

          const dataList = uuids.map(uuid => ({
            type: 'manual',
            applicationUuid: uuid
          }))

          CRUDService.batchCreate('send_stop', dataList).then((response) => {
            if (response && response.failed && Array.isArray(response.failed) && response.failed.length > 0) {
              const failedUuids = response.failed.map(item => item.applicationUuid).join(', ')
              this.$toast.add({
                severity: 'error',
                summary: 'Ошибка остановки',
                detail: `Failed: ${failedUuids}`,
                life: 5000
              })
            }

            const failedCount = response?.failed?.length || 0
            const successCount = uuids.length - failedCount

            if (successCount > 0) {
              const detail = successCount === 1
                  ? 'Передача данных в БКИ по заявке остановлена'
                  : `Передача данных в БКИ по ${successCount} заявкам остановлена`

              this.$toast.add({
                severity: 'success',
                summary: 'Передача остановлена',
                detail: detail,
                life: 2000
              })
            }

            this.$refs.form.clear()
            this.loading = false
          }).catch((err) => {
            ResponseService.handleErrorResponseWithForm(err, this.form, this.$toast)
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
